import apiCall from '../../index'

const apiService = '/api-erpunigas/api/v1/portal/diseno_header'
const authorization = 'Authorization'
const tipoToken = 'Bearer'

const service = {
  findAll(params) {
    const query = `?seccion=${params.seccion}&publicado=${params.publicado}&tipo=${params.tipo}&limit=${params.limit}&page=${params.page}&query=${params.query}&sortBy=${params.sortBy}`
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .get(apiService + query)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const formData = new FormData()
    formData.append('titulo', model.titulo)
    formData.append('subTitulo', model.subTitulo)
    formData.append('link', model.link)
    formData.append('caption', model.caption)
    formData.append('seccion', model.seccion)
    formData.append('orden', model.orden)
    formData.append('publicado', model.publicado)
    if (model.foto !== null) formData.append('foto', model.foto)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .post(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  update(model) {
    const formData = new FormData()
    formData.append('idDisenoHeader', model.idDisenoHeader)
    formData.append('titulo', model.titulo)
    formData.append('subTitulo', model.subTitulo)
    formData.append('link', model.link)
    formData.append('caption', model.caption)
    formData.append('seccion', model.seccion)
    formData.append('orden', model.orden)
    formData.append('publicado', model.publicado)
    if (model.foto !== null) formData.append('foto', model.foto)
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('accessToken')}`
      apiCall
        .put(apiService, formData)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  delete(params) {
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${tipoToken} ${localStorage.getItem('tokenPI')}`
      apiCall
        .delete(`${apiService}/${params.id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
